import React, { useState, useEffect } from 'react';

const AboutUs = ({ isVisible, onBack }) => {
    const [animate, setAnimate] = useState(false);

    // مدیریت انیمیشن ورود به صفحه
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => setAnimate(true), 100);
            return () => clearTimeout(timer);
        } else {
            setAnimate(false);
        }
    }, [isVisible]);

    // اگر صفحه فعال نیست، با کلاس hidden-page مخفی می‌شود (طبق ساختار کلی برنامه)
    return (
        <div id="page-about" className={`page-section ${isVisible ? '' : 'hidden-page'}`}>
            {/* استایل‌های اختصاصی این بخش */}
            <style>{`
                #about-wrapper {
                    transition: all 1.2s cubic-bezier(0.4, 0, 0.2, 1);
                    opacity: 0;
                    transform: translateY(20px);
                }
                #about-wrapper.active-anim {
                    opacity: 1;
                    transform: translateY(0);
                }
                .about-inner-card {
                    display: flex;
                    align-items: center;
                    flex-direction: row-reverse; 
                    gap: 2rem;
                    padding: 2rem;
                }
                #about-img {
                    width: 300px;
                    height: 400px;
                    object-fit: cover;
                    border-radius: 24px;
                    filter: grayscale(100%);
                    transition: filter 1.5s ease, transform 0.5s ease;
                    box-shadow: 0 20px 40px rgba(0,0,0,0.4);
                }
                #about-text-content {
                    opacity: 0;
                    transform: translateX(-20px);
                    transition: all 1s ease 0.3s;
                }
                #about-wrapper.active-anim #about-img {
                    filter: grayscale(0%);
                }
                #about-wrapper.active-anim #about-text-content {
                    opacity: 1;
                    transform: translateX(0);
                }
                @media (max-width: 768px) {
                    .about-inner-card {
                        flex-direction: column;
                        text-align: center;
                    }
                    #about-img {
                        width: 100%;
                        height: 350px;
                        margin-bottom: 1.5rem;
                    }
                    #about-text-content {
                        text-align: center;
                    }
                }
            `}</style>

            <div className="container mx-auto px-4 py-20 flex flex-col items-center justify-center min-h-[60vh] fade-in">
                <div id="about-wrapper" className={`glass-panel rounded-3xl w-full max-w-5xl mx-auto overflow-hidden ${animate ? 'active-anim' : ''}`}>
                    <div className="about-inner-card group">
                        <div id="about-text-content" className="flex-grow">
                            {/* برای سئو: نام شما در تگ h1 قرار گرفت */}
                            <h1 className="text-4xl font-black text-white mb-2">کیارش ارکانی</h1>
                            {/* برای سئو: عنوان شغلی در تگ h2 قرار گرفت */}
                            <h2 className="text-xl text-yellow-500 font-bold block mb-6">مدیر و موسس ارکانی عمران</h2>
                            
                            <div className="space-y-3 text-slate-300 text-lg leading-relaxed text-justify">
                                {/* برای سئو: نام شما در متن strong شد */}
                                <p>طراحی این نرم‌افزارها تماما توسط <strong className="text-white font-bold">کیارش ارکانی</strong> دانشجو دکتری دانشگاه صنعتی نوشیروانی بابل انجام شده است.</p>
                                <p>هدف ما ارائه ابزارهایی دقیق، سریع و منطبق با نیازهای مهندسین عمران ایران است تا فرآیند محاسبات سازه را لذت‌بخش‌تر و ایمن‌تر کنیم.</p>
                                <ul className="list-disc list-inside mt-4 space-y-2 text-slate-400 text-base">
                                    <li>دانشجوی دکتری مهندسی زلزله</li>
                                    <li>طراح و توسعه‌دهنده نرم‌افزارهای مهندسی</li>
                                    <li>مهندس و محاسب ساختمان</li>
                                    <li>مدرس دانشگاه</li>
                                    <li>طراح سایت</li>
                                </ul>
                                <p className="mt-4 text-sm text-slate-500">
                                    امید است با همراهی شما و ارائه بازخوردهای شما با بروزرسانی‌های آتی ایرادات احتمالی به حداقل خود رسیده و لایق مهندس های ایرانی باشد.
                                </p>
                            </div>
                            <div className="mt-8 flex gap-4">
                                <a href="https://t.me/arkaniomran" className="text-slate-900 bg-yellow-500 hover:bg-yellow-400 px-6 py-2 rounded-xl font-bold transition-colors">تماس با من</a>
                                <button onClick={onBack} className="text-slate-400 hover:text-white border border-slate-600 px-6 py-2 rounded-xl transition-colors">بازگشت</button>
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            {/* تغییر نام و آدرس عکس به همراه بهبود alt */}
                            <img 
                                src="/members/kiarash-arkani.png" 
                                id="about-img"
                                alt="کیارش ارکانی، مدیر و موسس ارکانی عمران" 
                                onError={(e) => {
                                    e.target.src='https://placehold.co/300x400?text=Kiarash+Arkani';
                                    e.target.style.objectFit='contain';
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
